export const LABELS = {
  heading: 'Maintenance request sent!',
  details:
    'All details of your issue have been sent to your property manager for processing. They will be in touch with you soon.',
  track: 'You can download our app to track the maintenance request',
  addAnother: 'Create more',
  download: 'Download',
};
